import { QUOTE_STATUSES } from '../constants';

/**
 * Return true if a quote is able to display a summary page.
 *
 * @param quote
 * @returns {boolean}
 */
export default function index(quote) {
  const nonSummaryStatuses = [
    QUOTE_STATUSES.CANCELLED.value,
    QUOTE_STATUSES.DRAFT.value,
    QUOTE_STATUSES.REQUESTED.value,
    QUOTE_STATUSES.SUBMITTED.value,
    QUOTE_STATUSES.AWAITINGPRICING.value
  ];
  return !nonSummaryStatuses.includes(quote.status);
}
